import { LandingHeroModule } from './HeroModule';
import { LandingInfoModule } from './InfoModule';
import { LandingFaqModule } from './FaqModule';

export const moduleComponentMap = {
  HERO_MODULE: LandingHeroModule,
  INFO_MODULE: LandingInfoModule,
  FAQ_MODULE: LandingFaqModule,
};
